<dx-data-grid
  [dataSource]="sensor.changes"
  [showRowLines]="true"
  height="320"
  [rowAlternationEnabled]="false"
  [hoverStateEnabled]="true"
  [columnAutoWidth]="true"
  [showBorders]="false">
  <dxo-scrolling mode="virtual"></dxo-scrolling>
  <dxi-column
    caption="Date"
    dataType="date"
    [sortIndex]="0"
    [groupIndex]="0"
    [calculateGroupValue]="calculateGroupValue"
    format="shortDateShortTime"
    dataField="time">
  </dxi-column>

  <dxi-column
    caption="Date"
    dataType="date"
    format="shortTime"
    dataField="time">
  </dxi-column>

  <dxi-column
    [caption]="'Changement' + (sensor.unit ? ' (' + sensor.unit + ')' : '')"
    dataType="number"
    cellTemplate="tmp"
    dataField="change">
    <div *dxTemplate="let d of 'tmp'">
      <span *ngIf="d.value <= 0" style="color:#ce312c">{{d.value | number: '1.0-0'}}</span>
      <span *ngIf="d.value > 0" style="color:#5cb85c">+{{d.text | number: '1.0-0'}}</span>
    </div>
  </dxi-column>

  <dxo-summary>
    <dxi-group-item
      column="change"
      [valueFormat]="'#0## '+sensor.unit"
      [displayFormat]="'Total: {0} '"
      [showInGroupFooter]="true"
      summaryType="sum">
    </dxi-group-item>
  </dxo-summary>
</dx-data-grid>
